"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cacheSearchValue = exports.getCachedSearchValues = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var CACHED_SEARCH_VALUES_KEY = 'ecosystem-marketplace-apps:searches';

var getCachedSearchValues = function getCachedSearchValues() {
  try {
    var parsedItem = JSON.parse(localStorage.getItem(CACHED_SEARCH_VALUES_KEY) || '[]');
    return Array.isArray(parsedItem) ? parsedItem : [];
  } catch (e) {
    return [];
  }
};

exports.getCachedSearchValues = getCachedSearchValues;

var cacheSearchValue = function cacheSearchValue(searchValue) {
  var cachedValues = getCachedSearchValues();

  if (cachedValues.includes(searchValue)) {
    return;
  }

  try {
    localStorage.setItem(CACHED_SEARCH_VALUES_KEY, JSON.stringify([searchValue].concat((0, _toConsumableArray2.default)(cachedValues)).slice(0, 4)));
  } catch (e) {
    return;
  }
};

exports.cacheSearchValue = cacheSearchValue;


//////////////////
// WEBPACK FOOTER
// ./js/utils/search.js
// module id = 759
// module chunks = 209 210 211 212